import { NationalFlagEmblem, type FlagEmblemKey } from '../../components/ui/NationalFlagEmblems';
import { ChevronRight } from '../../components/ui/icons';
import { CardHeader, CoverageRow, ListCard } from './shared';

// ── Step 3 · Cycling races ────────────────────────────────────────────────────
const CYCLING_ROWS: Array<{ name: string; group: string; flag: FlagEmblemKey }> = [
  { name: 'Tour de France', group: 'Grand Tour', flag: 'france' },
  { name: 'Tour of Flanders', group: 'Monument', flag: 'belgium' },
  { name: 'Strade Bianche', group: 'Classic', flag: 'italy' },
  { name: 'UCI Road Worlds', group: 'Worlds', flag: 'uci' }
];

export function CyclingCard() {
  return (
    <ListCard>
      <CardHeader
        label="Cycling races"
        trailing={<span className="text-[11px] font-bold text-ink3">Stage by stage</span>}
      />
      <div className="flex flex-col gap-[7px]">
        {CYCLING_ROWS.map(({ name, group, flag }) => (
          <CoverageRow
            key={name}
            emblem={<NationalFlagEmblem flag={flag} size="xs" />}
            name={name}
            sub={group}
            trailing={<ChevronRight width={15} height={15} strokeWidth={2.4} className="shrink-0 text-ink4" />}
          />
        ))}
      </div>
      <p className="mt-[10px] px-[3px] text-[11.5px] font-semibold text-ink3">
        + Giro, Vuelta, Paris-Roubaix &amp; more
      </p>
    </ListCard>
  );
}
